import { useMutation } from '@tanstack/react-query';

import { accessEngineRepo, paymentRepo } from '@ctct/domain-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';

export const usePayForPlanMutation = () => {
  const mutation = useMutation({
    mutationFn: paymentRepo.postPayment,
    onSuccess: () => {
      accessEngineRepo.invalidateCache().catch(() => {
        // best-effort: cache invalidation failure must not affect the purchase flow
      });
    },
  });

  return useMutationMemoized(mutation);
};

export type PayForPlanMutation = ReturnType<typeof usePayForPlanMutation>;
